import { createContext } from 'react'

const URLstateContext = createContext();

export default URLstateContext;